export const MY_ACCOUNT_GET_MY_TRIPS_BUS_BEGIN = 'MY_ACCOUNT_GET_MY_TRIPS_BUS_BEGIN';
export const MY_ACCOUNT_GET_MY_TRIPS_BUS_SUCCESS = 'MY_ACCOUNT_GET_MY_TRIPS_BUS_SUCCESS';
export const MY_ACCOUNT_GET_MY_TRIPS_BUS_FAILURE = 'MY_ACCOUNT_GET_MY_TRIPS_BUS_FAILURE';
export const MY_ACCOUNT_GET_MY_TRIPS_BUS_DISMISS_ERROR =
  'MY_ACCOUNT_GET_MY_TRIPS_BUS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_MY_TRANSACTIONS_BEGIN = 'MY_ACCOUNT_GET_MY_TRANSACTIONS_BEGIN';
export const MY_ACCOUNT_GET_MY_TRANSACTIONS_SUCCESS = 'MY_ACCOUNT_GET_MY_TRANSACTIONS_SUCCESS';
export const MY_ACCOUNT_GET_MY_TRANSACTIONS_FAILURE = 'MY_ACCOUNT_GET_MY_TRANSACTIONS_FAILURE';
export const MY_ACCOUNT_GET_MY_TRANSACTIONS_DISMISS_ERROR =
  'MY_ACCOUNT_GET_MY_TRANSACTIONS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_VIRTUAL_MONEY_BEGIN = 'MY_ACCOUNT_GET_VIRTUAL_MONEY_BEGIN';
export const MY_ACCOUNT_GET_VIRTUAL_MONEY_SUCCESS = 'MY_ACCOUNT_GET_VIRTUAL_MONEY_SUCCESS';
export const MY_ACCOUNT_GET_VIRTUAL_MONEY_FAILURE = 'MY_ACCOUNT_GET_VIRTUAL_MONEY_FAILURE';
export const MY_ACCOUNT_GET_VIRTUAL_MONEY_DISMISS_ERROR =
  'MY_ACCOUNT_GET_VIRTUAL_MONEY_DISMISS_ERROR';
export const MY_ACCOUNT_WALLET_RECHARGE_BEGIN = 'MY_ACCOUNT_WALLET_RECHARGE_BEGIN';
export const MY_ACCOUNT_WALLET_RECHARGE_SUCCESS = 'MY_ACCOUNT_WALLET_RECHARGE_SUCCESS';
export const MY_ACCOUNT_WALLET_RECHARGE_FAILURE = 'MY_ACCOUNT_WALLET_RECHARGE_FAILURE';
export const MY_ACCOUNT_WALLET_RECHARGE_DISMISS_ERROR = 'MY_ACCOUNT_WALLET_RECHARGE_DISMISS_ERROR';
export const MY_ACCOUNT_GET_RECHARGE_LOCATIONS_BEGIN = 'MY_ACCOUNT_GET_RECHARGE_LOCATIONS_BEGIN';
export const MY_ACCOUNT_GET_RECHARGE_LOCATIONS_SUCCESS =
  'MY_ACCOUNT_GET_RECHARGE_LOCATIONS_SUCCESS';
export const MY_ACCOUNT_GET_RECHARGE_LOCATIONS_FAILURE =
  'MY_ACCOUNT_GET_RECHARGE_LOCATIONS_FAILURE';
export const MY_ACCOUNT_GET_RECHARGE_LOCATIONS_DISMISS_ERROR =
  'MY_ACCOUNT_GET_RECHARGE_LOCATIONS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_CUSTOMER_INFO_BEGIN = 'MY_ACCOUNT_GET_CUSTOMER_INFO_BEGIN';
export const MY_ACCOUNT_GET_CUSTOMER_INFO_SUCCESS = 'MY_ACCOUNT_GET_CUSTOMER_INFO_SUCCESS';
export const MY_ACCOUNT_GET_CUSTOMER_INFO_FAILURE = 'MY_ACCOUNT_GET_CUSTOMER_INFO_FAILURE';
export const MY_ACCOUNT_GET_CUSTOMER_INFO_DISMISS_ERROR =
  'MY_ACCOUNT_GET_CUSTOMER_INFO_DISMISS_ERROR';
export const MY_ACCOUNT_UPDATE_FAVOURITES_BEGIN = 'MY_ACCOUNT_UPDATE_FAVOURITES_BEGIN';
export const MY_ACCOUNT_UPDATE_FAVOURITES_SUCCESS = 'MY_ACCOUNT_UPDATE_FAVOURITES_SUCCESS';
export const MY_ACCOUNT_UPDATE_FAVOURITES_FAILURE = 'MY_ACCOUNT_UPDATE_FAVOURITES_FAILURE';
export const MY_ACCOUNT_UPDATE_FAVOURITES_DISMISS_ERROR =
  'MY_ACCOUNT_UPDATE_FAVOURITES_DISMISS_ERROR';
export const MY_ACCOUNT_GET_PROFILE_BEGIN = 'MY_ACCOUNT_GET_PROFILE_BEGIN';
export const MY_ACCOUNT_GET_PROFILE_SUCCESS = 'MY_ACCOUNT_GET_PROFILE_SUCCESS';
export const MY_ACCOUNT_GET_PROFILE_FAILURE = 'MY_ACCOUNT_GET_PROFILE_FAILURE';
export const MY_ACCOUNT_GET_PROFILE_DISMISS_ERROR = 'MY_ACCOUNT_GET_PROFILE_DISMISS_ERROR';
export const MY_ACCOUNT_TRANSFER_MONEY_BEGIN = 'MY_ACCOUNT_TRANSFER_MONEY_BEGIN';
export const MY_ACCOUNT_TRANSFER_MONEY_SUCCESS = 'MY_ACCOUNT_TRANSFER_MONEY_SUCCESS';
export const MY_ACCOUNT_TRANSFER_MONEY_FAILURE = 'MY_ACCOUNT_TRANSFER_MONEY_FAILURE';
export const MY_ACCOUNT_TRANSFER_MONEY_DISMISS_ERROR = 'MY_ACCOUNT_TRANSFER_MONEY_DISMISS_ERROR';
export const MY_ACCOUNT_GET_QR_BEGIN = 'MY_ACCOUNT_GET_QR_BEGIN';
export const MY_ACCOUNT_GET_QR_SUCCESS = 'MY_ACCOUNT_GET_QR_SUCCESS';
export const MY_ACCOUNT_GET_QR_FAILURE = 'MY_ACCOUNT_GET_QR_FAILURE';
export const MY_ACCOUNT_GET_QR_DISMISS_ERROR = 'MY_ACCOUNT_GET_QR_DISMISS_ERROR';
export const MY_ACCOUNT_GET_POOL_TRIPS_BEGIN = 'MY_ACCOUNT_GET_POOL_TRIPS_BEGIN';
export const MY_ACCOUNT_GET_POOL_TRIPS_SUCCESS = 'MY_ACCOUNT_GET_POOL_TRIPS_SUCCESS';
export const MY_ACCOUNT_GET_POOL_TRIPS_FAILURE = 'MY_ACCOUNT_GET_POOL_TRIPS_FAILURE';
export const MY_ACCOUNT_GET_POOL_TRIPS_DISMISS_ERROR = 'MY_ACCOUNT_GET_POOL_TRIPS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_KUPOS_GO_TRIPS_BEGIN = 'MY_ACCOUNT_GET_KUPOS_GO_TRIPS_BEGIN';
export const MY_ACCOUNT_GET_KUPOS_GO_TRIPS_SUCCESS = 'MY_ACCOUNT_GET_KUPOS_GO_TRIPS_SUCCESS';
export const MY_ACCOUNT_GET_KUPOS_GO_TRIPS_FAILURE = 'MY_ACCOUNT_GET_KUPOS_GO_TRIPS_FAILURE';
export const MY_ACCOUNT_GET_KUPOS_GO_TRIPS_DISMISS_ERROR =
  'MY_ACCOUNT_GET_KUPOS_GO_TRIPS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_MY_AT_TRIPS_BEGIN = 'MY_ACCOUNT_GET_MY_AT_TRIPS_BEGIN';
export const MY_ACCOUNT_GET_MY_AT_TRIPS_SUCCESS = 'MY_ACCOUNT_GET_MY_AT_TRIPS_SUCCESS';
export const MY_ACCOUNT_GET_MY_AT_TRIPS_FAILURE = 'MY_ACCOUNT_GET_MY_AT_TRIPS_FAILURE';
export const MY_ACCOUNT_GET_MY_AT_TRIPS_DISMISS_ERROR = 'MY_ACCOUNT_GET_MY_AT_TRIPS_DISMISS_ERROR';
export const MY_ACCOUNT_GET_MY_TRAIN_TRIPS_BEGIN = 'MY_ACCOUNT_GET_MY_TRAIN_TRIPS_BEGIN';
export const MY_ACCOUNT_GET_MY_TRAIN_TRIPS_SUCCESS = 'MY_ACCOUNT_GET_MY_TRAIN_TRIPS_SUCCESS';
export const MY_ACCOUNT_GET_MY_TRAIN_TRIPS_FAILURE = 'MY_ACCOUNT_GET_MY_TRAIN_TRIPS_FAILURE';
export const MY_ACCOUNT_GET_MY_TRAIN_TRIPS_DISMISS_ERROR =
  'MY_ACCOUNT_GET_MY_TRAIN_TRIPS_DISMISS_ERROR';
export const ADD_BIP_CARD = 'ADD_BIP_CARD';
export const MY_ACCOUNT_ADD_BIP_CARD_BEGIN = 'MY_ACCOUNT_ADD_BIP_CARD_BEGIN';
export const MY_ACCOUNT_ADD_BIP_CARD_SUCCESS = 'MY_ACCOUNT_ADD_BIP_CARD_SUCCESS';
export const MY_ACCOUNT_ADD_BIP_CARD_FAILURE = 'MY_ACCOUNT_ADD_BIP_CARD_FAILURE';
export const MY_ACCOUNT_ADD_BIP_CARD_DISMISS_ERROR = 'MY_ACCOUNT_ADD_BIP_CARD_DISMISS_ERROR';
export const MY_ACCOUNT_API_CALL_BEGIN = 'MY_ACCOUNT_API_CALL_BEGIN';
export const MY_ACCOUNT_API_CALL_SUCCESS = 'MY_ACCOUNT_API_CALL_SUCCESS';
export const MY_ACCOUNT_API_CALL_FAILURE = 'MY_ACCOUNT_API_CALL_FAILURE';
export const MY_ACCOUNT_API_CALL_DISMISS_ERROR = 'MY_ACCOUNT_API_CALL_DISMISS_ERROR';
export const MY_ACCOUNT_SAVE_BIP_DETAILS = 'MY_ACCOUNT_SAVE_BIP_DETAILS';



// WEBPACK FOOTER //
// ./src/features/my-account/redux/constants.js